// src/googleAuthConfig.js
export const clientId = "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";
